/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const usePlanCardStyles = makeStyles(theme => ({
  root: {
    width: '135px',
    minHeight: '80px',
    maxHeight: '130px',
    boxShadow: 'none',
    overflow: 'visible',
    backgroundColor: '#F6F7F8',
    position: 'relative',
    padding: '16px',
    cursor: 'pointer',
  },
  price: {
    marginBottom: '35px',
  },
  priceAmount: {
    color: theme.palette.primary.main,
    fontSize: '24px',
    lineHeight: '24px',
    fontWeight: 400,
  },
  priceDuration: {
    fontSize: '12px',
    lineHeight: '12px',
    color: theme.palette.text.primary,
    marginLeft: '2px',
    fontWeight: 400,
  },
  description: {},
  name: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  type: {
    color: theme.palette.text.primary,
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 400,
  },
  bottomTip: {
    position: 'absolute',
    maxWidth: '90%',
    height: '20px',
    borderRadius: '10px',
    background: theme.palette.primary.main,
    color: '#FFFFFF',
    padding: '4px 11px',
    fontSize: '10px',
    lineHeight: '12px',
    bottom: 0,
    left: '50%',
    transform: 'translate(-50%, 50%)',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  descriptionOnly: {
    display: 'flex',
    alignItems: 'center',
  },
}));
